import React from 'react';

const bookingSteps = [
  {
    title: 'Set your route',
    description:
      'Enter pickup and drop-off. The website gives a route-based estimate before you commit to anything.',
  },
  {
    title: 'Pick a truck & confirm',
    description:
      'Choose the vehicle that fits the load and confirm the fare. Dispatch now here, or schedule for later in the app.',
  },
  {
    title: 'Track to the door',
    description:
      'One driver is secured at a time. Follow them from match to drop-off, and message in the booking thread.',
  },
];

const HowItWorksSection: React.FC = () => {
  return (
    <section className="sw-section">
      <div className="container">
        <div className="sw-section-head">
          <span className="sw-eyebrow">How it works</span>
          <h2>Booked in three taps.</h2>
          <p>
            ShiftWagon keeps truck booking simple so first-time customers know exactly what to do.
          </p>
        </div>

        <div className="sw-steps sw-steps-3">
          {bookingSteps.map((step, index) => (
            <article className="sw-step" key={step.title}>
              <span className="sw-step-num">0{index + 1}</span>
              <h3 className="sw-step-title">{step.title}</h3>
              <p className="sw-step-copy">{step.description}</p>
            </article>
          ))}
        </div>

        <p className="sw-note">
          <strong>Drivers have their own app flow.</strong>
          Approved drivers manage availability, receive jobs, and may propose a revised fare
          when load details change the work before loading starts.
        </p>
      </div>
    </section>
  );
};

export default HowItWorksSection;
